// extracted by mini-css-extract-plugin
export var checkboxInputRow = "D_vc";
export var checkboxInputColumn = "D_vd";
export var inputOptionRow = "D_qM";
export var inputOptionColumn = "D_qN";